import { Box, Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { BsCheck } from "react-icons/bs";
import RcForm1 from "../Components/RegistrationCertifiates/RcForm1";
import RcForm2 from "../Components/RegistrationCertifiates/RcForm2";
import RcForm3 from "../Components/RegistrationCertifiates/RcForm3";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  applyForm,
  getCommodity,
  getGeoCodes,
  getProcess,
  getProgram,
  getSuggestions,
} from "../api";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { getAllCommoditities } from "../redux/commodity/CommoditySlice";
import axios from "axios";
import { toast } from "react-toastify";
import cuLogo from "../assets/images/cu_logo.png";
import emertechLogo from "../assets/images/Emertech_Logo.png";
import cuPrograms from "../assets/images/cu_programs-trans.png";
import cuLogo2 from "../assets/images/cu_100-trans.png";
import { Loader } from "../assets/svgs/Icons";
import dompurify from "dompurify";

export const INITIAL_VALUES = {
  name: "",
  state: "",
  city: "",
  pinCode: "",
  country: "",
  raw_address: "",
  unitType: "",
  numberOfEmployees: null,
};

export const PRODUCT_INITIAL_VALUES = {
  productName: "",
  productCategory: "",
  productClassification: "",
  productCertification: "",
  productCommodity: "",
  productLabelGrade: "",
};

function RegistrationCertificate() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [processValues, setProcessValues] = useState([]);
  const [selectedProcessValue, setSelectedProcessValue] = useState([]);
  const [customProcessValue, setCustomProcessValue] = useState([]);
  const [selectedUnitProcess, setSelectedUnitProcess] = useState([]);
  const [programValues, setProgramValues] = useState([]);
  const [selectedProgramValue, setSelectedProgramValue] = useState([]);
  const [customProgramValue, setCustomProgramValue] = useState([]);
  const [commodityValues, setCommodityValues] = useState([]);
  const [labelGrade, setLabelGrade] = useState("");
  const [unitAddress, setUnitAddress] = useState("");
  const [coordinates, setCoordinates] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [openSuggestions, setOpenSuggestions] = useState(false);
  const [selectedCommodityValue, setSelectedCommodityValue] = useState([]);
  const [customCommodityValue, setCustomCommodityValue] = useState([]);
  const [unitValues, setUnitValues] = useState(INITIAL_VALUES);
  const [productValues, setProductValues] = useState(PRODUCT_INITIAL_VALUES);
  const [units, setUnits] = useState([]);
  const [products, setProducts] = useState([]);
  const [files, setFiles] = useState([]);
  const [rc2error1, setRc2Error1] = useState(false);
  const [rc2error2, setRc2Error2] = useState(false);
  const [rc2error3, setRc2Error3] = useState(false);
  const [rc2error4, setRc2Error4] = useState(false);
  const [rc2error5, setRc2Error5] = useState(false);
  const [rc2error6, setRc2Error6] = useState(false);
  const [rc2error7, setRc2Error7] = useState(false);
  const [rc3error1, setRc3Error1] = useState(false);
  const [rc3error2, setRc3Error2] = useState(false);
  const [rc3error3, setRc3Error3] = useState(false);
  const [rc3error4, setRc3Error4] = useState(false);
  const [rc3error5, setRc3Error5] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [unitTypes, setUnitTypes] = useState([
    "MAIN",
    "FACILITY",
    "INTERNAL SUBCONTRACTOR",
    "EXTERNAL SUBCONTRACTOR",
  ]);
  const [isSecondChecked, setIsSecondChecked] = useState(false);

  const token = localStorage.getItem("cu_user");

  // To check and update state for declaration checkbox

  const [declare, setDeclare] = useState(false);

  const dispatch = useDispatch();

  const { allCommodities } = useSelector((state) => state.commodity);

  const getProcessList = async () => {
    let response = await getProcess();
    let responseData = response?.data?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setProcessValues(responseData);
  };

  const getProgramList = async () => {
    let response = await getProgram();
    let responseData = response?.data?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setProgramValues(responseData);
  };

  const getCommodityData = async () => {
    let response = await getCommodity();
    let responseData = response?.data?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });

    setCommodityValues(responseData);
  };

  const getCommodities = () => {
    try {
      const result = dispatch(getAllCommoditities());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const setGeoCode = async (address) => {
    const response = await getGeoCodes(address);

    setCoordinates(response?.data?.location);
    if (unitAddress) {
      setOpenSuggestions(true);
    }
  };

  const getSetSuggestions = async (address) => {
    const response = await getSuggestions(address);

    setSuggestions(response?.data?.predictions);
    if (response?.data?.predictions) {
      setOpenSuggestions(true);
    }
  };

  const uploadDocuments = async () => {
    const fileFormData = new FormData();

    files.forEach((file) => {
      fileFormData.append("document", file);
    });

    try {
      const fileUploadRequest = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_HOST}/api/document/multiple/upload`,
        data: fileFormData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return fileUploadRequest.data?.data?.map((file) => file?._id);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    setIsloading(false);
  };

  useEffect(() => {
    if (unitAddress) {
      setGeoCode(unitAddress);
      getSetSuggestions(unitAddress);
    }
  }, [unitAddress]);

  const STEP_FORMS = [
    {
      id: 0,
      component: (
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setErrors,
        setFieldValue,
        setFieldError
      ) => (
        <RcForm1
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleSubmit={handleSubmit}
          setErrors={setErrors}
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
        />
      ),
    },
    {
      id: 1,
      component: (
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit
      ) => (
        <RcForm2
          values={values}
          setSelectedUnitProcess={setSelectedUnitProcess}
          selectedUnitProcess={selectedUnitProcess}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleSubmit={handleSubmit}
          processValues={processValues}
          setProcessValues={setProcessValues}
          selectedProcessValue={selectedProcessValue}
          setSelectedProcessValue={setSelectedProcessValue}
          customProcessValue={customProcessValue}
          setCustomProcessValue={setCustomProcessValue}
          programValues={programValues}
          setProgramValues={setProgramValues}
          selectedProgramValue={selectedProgramValue}
          setSelectedProgramValue={setSelectedProgramValue}
          customProgramValue={customProgramValue}
          setCustomProgramValue={setCustomProgramValue}
          units={units}
          setUnits={setUnits}
          unitValues={unitValues}
          setUnitValues={setUnitValues}
          rc2error1={rc2error1}
          setRc2Error1={setRc2Error1}
          rc2error2={rc2error2}
          setRc2Error2={setRc2Error2}
          rc2error3={rc2error3}
          rc2error4={rc2error4}
          rc2error5={rc2error5}
          rc2error6={rc2error6}
          setRc2Error3={setRc2Error3}
          setRc2Error4={setRc2Error4}
          setRc2Error5={setRc2Error5}
          setRc2Error6={setRc2Error6}
          rc2error7={rc2error7}
          setRc2Error7={setRc2Error7}
          setUnitAddress={setUnitAddress}
          unitAddress={setUnitAddress}
          setSuggestions={setSuggestions}
          setOpenSuggestions={setOpenSuggestions}
          suggestions={suggestions}
          openSuggestions={openSuggestions}
          coordinates={coordinates}
          setCoordinates={setCoordinates}
          isSecondChecked={isSecondChecked}
          unitTypes={unitTypes}
          setUnitTypes={setUnitTypes}
          setIsSecondChecked={setIsSecondChecked}
        />
      ),
    },
    {
      id: 2,
      component: (
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        resetForm,
        handleSubmit
      ) => (
        <RcForm3
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleSubmit={handleSubmit}
          products={products}
          setProducts={setProducts}
          setFiles={setFiles}
          files={files}
          setDeclare={setDeclare}
          commodityValues={commodityValues}
          setCommodityValues={setCommodityValues}
          selectedCommodityValue={selectedCommodityValue}
          setSelectedCommodityValue={setSelectedCommodityValue}
          customCommodityValue={customCommodityValue}
          setCustomCommodityValue={setCustomCommodityValue}
          resetForm={resetForm}
          setProductValues={setProductValues}
          productValues={productValues}
          rc3error1={rc3error1}
          rc3error2={rc3error2}
          rc3error3={rc3error3}
          rc3error4={rc3error4}
          rc3error5={rc3error5}
          setRc3Error1={setRc3Error1}
          setRc3Error2={setRc3Error2}
          setRc3Error3={setRc3Error3}
          setRc3Error4={setRc3Error4}
          setRc3Error5={setRc3Error5}
          documents={documents}
          setDocuments={setDocuments}
        />
      ),
    },
  ];

  const customizedCommodityValues = () => {};

  useEffect(() => {
    getProcessList();
    getProgramList();
    getCommodities();
    getCommodityData();
    customizedCommodityValues();
  }, []);

  return (
    <Box marginBottom={"2rem"} padding={{ base: "2rem 1rem", lg: "2rem 5rem" }}>
      <Box display={"flex"} justifyContent="space-between">
        <Link
          display={"flex"}
          justifyContent="left"
          alignItems={"center"}
          paddingLeft={"2rem"}
          target={"_blank"}
          rel="noreferrer noopener"
          href="https://certifications.controlunion.com/en"
        >
          <Image src={cuLogo2} width="180px" />
          <Box
            as="span"
            borderRight={"2px solid #aaaa"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          <Image src={cuLogo} width="220px" />
        </Link>
        {/* <Box>
          <Image src={cuPrograms} width="450px" />
        </Box> */}
      </Box>
      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Registration Certificate Form
        </Text>
        <Text color={" #3958DC"} fontSize="sm">
          Please fill necessary details
        </Text>
      </Box>
      <Box
        marginTop={"1.5rem"}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft={{ base: "-1rem", lg: "-5rem" }}
        marginRight={{ base: "-1rem", lg: "-4.5rem" }}
      >
        Registration Certificate Form Details
      </Box>

      <Flex justifyContent={"center"} alignItems={"center"} mt={"3rem"}>
        {STEP_FORMS.map((curStep, index) => (
          <>
            <Box
              rounded={"full"}
              display={"flex"}
              justifyContent="center"
              alignItems={"center"}
              width="30px"
              height={"30px"}
              background={index === step ? "#52BBFF" : "transparent"}
            >
              <Box
                border={"3px solid #E2E8F0"}
                rounded={"full"}
                bg={
                  index < step
                    ? "#52BBFF"
                    : index === step
                    ? "#8fd0fd"
                    : "gray.400"
                }
                width="25px"
                height="25px"
                display={"flex"}
                justifyContent="center"
                alignItems={"center"}
              >
                {index < step && <BsCheck color="white" size={16} />}
              </Box>
            </Box>
            {!(index === STEP_FORMS.length - 1) && (
              <Box
                width="150px"
                height={"2px"}
                bg={index < step ? "#52BBFF" : "gray.400"}
              />
            )}
          </>
        ))}
      </Flex>

      <Formik
        initialValues={{
          organizationName: "",
          organizationLattitude: "",
          organizationLongitude: "",
          organizationRawAddress: "",
          organizationCity: "",
          organizationState: "",
          organizationCountry: "",
          organizationPinCode: "",
          organizationWebsite: "",
          organizationCompanyScale: "",
          legalName: "",
          legalContact: "",
          legalEmail: "",
          contactName: "",
          contactEmail: "",
          contactNumber: "",
          contactDescription: "",
          processIds: [],
          programIds: [],
          declaration: "",
          productName: "",
          productCategory: "",
          productClassification: "",
          productCertification: "",
          productGrade: "",
          productCommodity: "",
          productPercent: "",
        }}
        onSubmit={async (values, { resetForm }) => {
          setIsloading(true);
          const documentIds = await uploadDocuments();
          if (units.length <= 0) {
            return toast.info(
              "Please add at least one unit before submitting."
            );
          }

          if (products.length <= 0) {
            return toast.info(
              "Please add at least one product before submitting."
            );
          }

          if (documentIds === undefined) {
            return toast.info(
              "Please add at least one GST or any company related document."
            );
          }

          let rcFarmValues = {
            name: dompurify.sanitize(values.organizationName),
            companyScale: dompurify.sanitize(values.organizationCompanyScale),
            address: {
              state: dompurify.sanitize(values.organizationState),
              city: dompurify.sanitize(values.organizationCity),
              country: dompurify.sanitize(values.organizationCountry),
              pinCode: values.organizationPinCode,
              raw_address: dompurify.sanitize(values.organizationRawAddress),
            },
            documentsForVerification: documentIds,
            website: dompurify.sanitize(values.organizationWebsite),
            legalRepresentative: {
              name: dompurify.sanitize(values.legalName),
              contact: values.legalContact,
              email: dompurify.sanitize(values.legalEmail),
            },
            contactPerson: {
              name: dompurify.sanitize(values.contactName),
              contact: values.contactNumber,
              email: dompurify.sanitize(values.contactEmail),
            },
            // commodity: "63da651044ff195c4475a603",
            description: dompurify.sanitize(values.contactDescription),
            units: units,
            products: products,
          };
          let response = await applyForm(rcFarmValues, resetForm, setIsloading);

          if (response?.data?.status === "success") {
            setUnits([]);
            setProducts([]);
            setFiles([]);
            setUnitTypes([
              "MAIN",
              "FACILITY",
              "INTERNAL SUBCONTRACTOR",
              "EXTERNAL SUBCONTRACTOR",
            ]);
            navigate("/rc-form");
            setStep(0);
            setIsChecked(false);
          }
        }}
        validationSchema={Yup.object().shape({
          organizationCompanyScale: Yup.string().required(
            "Company Scale field is required"
          ),
          organizationName: Yup.string().required(
            "Organization Name field is required"
          ),
          organizationRawAddress: Yup.string().required(
            "organization Address is Required"
          ),
          organizationState: Yup.string().required(
            "organization state is Required"
          ),
          organizationWebsite: Yup.string().matches(
            /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,6})(\/\S*)?$/,
            "Invalid website domain"
          ),
          legalName: Yup.string().required("Name field is required"),
          legalEmail: Yup.string().required("Email field is required"),
          legalContact: Yup.string()
            .required("Number field is required")
            .matches(
              /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
              "Please enter a valid phone number"
            )
            .test(
              "is-ten-digits",
              "Phone number should be exactly 10 characters",
              (value) => value && value.replace(/\D/g, "").length === 10
            ),
          contactName: Yup.string().required("Name field is required"),
          contactEmail: Yup.string().required("Email field is required"),
          contactNumber: Yup.string()
            .required("Number field is required")
            .matches(
              /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
              "Please enter a valid phone number"
            )
            .test(
              "is-ten-digits",
              "Phone number should be exactly 10 characters",
              (value) => value && value.replace(/\D/g, "").length === 10
            ),
        })}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            validateForm,
            setErrors,
            setFieldValue,
            setFieldError,
          } = props;
          return (
            <>
              <form onSubmit={handleSubmit}>
                {STEP_FORMS[step].component(
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  resetForm,
                  setErrors,
                  setFieldValue,
                  setFieldError
                )}
              </form>

              <Flex mt={"2rem"} gap="2rem" justifyContent={"center"}>
                <Button
                  onClick={() =>
                    step > 0 && setStep((prevStep) => prevStep - 1)
                  }
                  bg={step > 0 ? "#52BBFF" : "gray.200"}
                  _hover={step > 0 && { bg: "#3fa7eb" }}
                  color="white"
                  cursor={step > 0 ? "pointer" : "not-allowed"}
                >
                  <IoMdArrowRoundBack size={22} />
                </Button>
                {step === 2 ? (
                  <Button
                    disabled={
                      !declare || isLoading
                        ? true
                        : "" || files?.length === 0 || products?.length === 0
                    }
                    onClick={() => handleSubmit()}
                    bg={"#52BBFF"}
                    _hover={{ bg: "#3fa7eb" }}
                    color="white"
                    cursor={"pointer"}
                  >
                    {isLoading ? (
                      <Loader width="25px" height="25px" />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                ) : (
                  <Button
                    isDisabled={step === 1 && units.length === 0}
                    onClick={() => {
                      if (step === 1 && units.length === 0) {
                        toast.error(
                          "Please add atleast one unit to go to last page"
                        );
                      } else {
                        validateForm().then((res) => {
                          if (!(Object.keys(res).length > 0)) {
                            setStep((prevStep) => prevStep + 1);
                          } else {
                            if (
                              res.organizationWebsite ===
                              "Invalid website domain"
                            ) {
                              toast.error("Please fill correct website domain");
                            } else {
                              toast.error(
                                "Please fill the required fields correctly"
                              );
                            }
                          }
                        });
                      }
                    }}
                    bg={step < 2 ? "#52BBFF" : "gray.200"}
                    _hover={step < 2 && { bg: "#3fa7eb" }}
                    color="white"
                    cursor={step < 2 ? "pointer" : "not-allowed"}
                  >
                    <IoMdArrowRoundForward size={22} />
                  </Button>
                )}
              </Flex>
            </>
          );
        }}
      </Formik>
      <Box
        marginTop={"5rem"}
        display={"flex"}
        justifyContent="center"
        alignItems={"center"}
        flexDirection="column"
      >
        <Box>
          <Text color={"#141D43"} fontSize="xs" fontWeight={"500"}>
            Powered by
          </Text>
        </Box>
        <a
          target={"_blank"}
          rel="noreferrer noopener"
          href="https://emertech.io/"
        >
          <Image src={emertechLogo} width="120px" />
        </a>
      </Box>
    </Box>
  );
}

export default RegistrationCertificate;
